import { render, staticRenderFns } from "./NavBtn.vue?vue&type=template&id=49414f6c&scoped=true&"
import script from "./NavBtn.vue?vue&type=script&lang=js&"
export * from "./NavBtn.vue?vue&type=script&lang=js&"
import style0 from "./NavBtn.vue?vue&type=style&index=0&id=49414f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49414f6c",
  null
  
)

export default component.exports